import {
  DecisionPageLayout,
  DecisionSection,
  DecisionSubHeading,
  DecisionList,
  InlineRelatedLinks,
} from "@/components/DecisionPageLayout";
import { Link } from "@/lib/router-compat";

const seo = {
  title:
    "What to Expect From Your Consultation | Neuro Wellness TMS Centers of America",
  description:
    "Preparing for your consultation at Neuro Wellness TMS Centers of America: what we'll review, what to bring, and what happens next.",
  canonical: "/what-to-expect-from-your-consultation",
  keywords:
    "TMS consultation, SAINT consultation, what to expect depression treatment consultation, Neuro Wellness consultation Florida",
};

const relatedLinks = [
  { title: "How Soon Can I Be Seen?", href: "/how-soon-can-i-be-seen" },
  { title: "Am I a Candidate?", href: "/am-i-a-candidate" },
  { title: "Insurance Verification", href: "/how-insurance-works" },
  { title: "Schedule a Consultation", href: "/contactus" },
];

export default function WhatToExpectFromYourConsultation() {
  return (
    <DecisionPageLayout
      seo={seo}
      badge="Consultation"
      title="What to Expect From Your Consultation"
      subtitle="Your first visit is a conversation, not a commitment. Here's what happens and how to prepare."
    >
      <DecisionSection heading="What the consultation is">
        <p>
          A consultation at Neuro Wellness TMS Centers of America is a
          discussion with our clinical team. We review your history, what you've
          tried, what's worked and what hasn't, and whether TMS, SAINT,
          SPRAVATO, or another treatment may be appropriate for you.
        </p>
        <p>
          There's no treatment on day one. No commitment. Just an evaluation to
          find out what fits.
        </p>
      </DecisionSection>

      <DecisionSection heading="What we'll review">
        <DecisionList
          items={[
            "Your depression history and current symptoms",
            "Medications you've tried, including doses and how long you took them",
            "Any prior TMS, ECT, or other neuromodulation treatments",
            "Your current medications and prescriber",
            "Whether you've had psychotherapy and what type",
            "Your insurance plan and what it may cover",
            "Any medical conditions that may affect treatment eligibility",
          ]}
        />
      </DecisionSection>

      <DecisionSection heading="What to bring">
        <DecisionList
          items={[
            "Your insurance card (front and back)",
            "A list of antidepressants you've tried, with approximate dates and outcomes",
            "Your current prescriber's name and contact information",
            "Any relevant medical records, if available",
            "Questions you want to ask — write them down beforehand",
          ]}
        />
      </DecisionSection>

      <DecisionSection heading="What happens after">
        <p>
          If TMS, SAINT, or another treatment seems appropriate, our team begins
          the insurance verification and authorization process. We'll tell you
          what your plan covers and what your out-of-pocket costs may be before
          you commit to anything.
        </p>
        <p>
          If none of our treatments are the right fit, we'll tell you that and
          discuss what might be.
        </p>
      </DecisionSection>

      <DecisionSection heading="Start now">
        <p>
          Call{" "}
          <a
            href="tel:9548279793"
            className="text-accent font-semibold hover:underline"
          >
            (954) 827-9793
          </a>{" "}
          or{" "}
          <Link to="/contactus" className="text-accent hover:underline">
            schedule a consultation
          </Link>
          .
        </p>
      </DecisionSection>

      <InlineRelatedLinks heading="Related Pages" links={relatedLinks} />
    </DecisionPageLayout>
  );
}
